var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serverData)?_c('div',{staticClass:"pb-12"},[_c('DashboardAsnFloorGroup',{attrs:{"counters":_vm.counters,"items":_vm.items,"headers":_vm.headers}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }